import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

const ElectionReminderSuccessMultiActionsCard = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent titleNoRep={props.title} />}
            {...props}
        />
    </TransitionContainerNoExit>
);

ElectionReminderSuccessMultiActionsCard.propTypes = {
    thankYouText: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
};

export default connect(
    state => ({
        title: `You're now signed up to receive reminders for upcoming elections.`,
        thankYouText: `You'll be getting emails in advance of major electoral events such as your state primaries and general elections. Make your voice heard.`
    }),
    {}
)(ElectionReminderSuccessMultiActionsCard);



// WEBPACK FOOTER //
// ./src/containers/ElectionReminder/ElectionReminderSuccessMultiActionsCard.jsx